import { BrainType } from "./review";

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

interface Address {
  address1: string;
  address2?: string;
  address3?: string;
  city: string;
  state?: string;
  country: string;
  postalCode?: string;
}

interface UserDetail {
  idx: number;
  email: string;
  birthday: string;
  gender: Gender;
  phoneNumber: string;
  address: Address;
  codePhone: string;
  name: string;
  profiles: UserProfile[];
}

interface UserProfile {
  idx: number;
  userIdx: number;
  currentTestType: string;
  name: string;
  isDeleted: boolean;
  isOwnerProfile: boolean;
  testCnt: number;
  createAt: string;
}

interface SecuredUserProfile {
  name: string;
  region: string;
  gender?: Gender;
  age: number;
}

interface TesterInfo {
  region: string;
  age: number;
  gender: Gender;
  brainType: BrainType;
}

interface UserResponse {
  user: UserDetail;
  userProfile: UserProfile[];
}

export type { Address, UserDetail, UserProfile, UserResponse, SecuredUserProfile, TesterInfo };
